import { MetadataIcon } from "@/types";
import { colors } from "../IconSelector";

export const defaultOrganizationIcon: MetadataIcon = {
  type: "lucide",
  lucide: {
    name: "Building2",
    color: colors[1] as string,
  },
};

export const defaultAssistantIcon: MetadataIcon = {
  type: "lucide",
  lucide: {
    name: "BotMessageSquare",
    color: colors[6] as string,
  },
};

export const defaultChatIcon: MetadataIcon = {
  type: "lucide",
  lucide: {
    name: "MessagesSquare",
    color: colors[1] as string,
  },
};

export const defaultProjectIcon: MetadataIcon = {
  type: "lucide",
  lucide: {
    name: "Folder",
    color: colors[5] as string,
  },
};

export const defaultSuggestionIcon: MetadataIcon = {
  type: "lucide",
  lucide: {
    name: "MessagesSquare",
    color: colors[1] as string,
  },
};

export const defaultGroupIcon: MetadataIcon = {
  type: "lucide",
  lucide: {
    name: "Users",
    color: colors[4] as string,
  },
};

export const defaultUserIcon: MetadataIcon = {
  type: "lucide",
  lucide: {
    name: "User",
    color: colors[3] as string,
  },
};

export const defaultResourceIcon: MetadataIcon = {
  type: "lucide",
  lucide: {
    name: "User",
    color: colors[3] as string,
  },
};
